<template>
  <v-dialog v-model="dialog.show" max-width="500" tile>
    <v-card tile>
      <v-toolbar :color="getAppBarColor" dark>{{ script.descricao }}</v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="mt-2">
        <v-textarea :value="script.conteudo" label="Conteudo" readonly />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="dialog.show = false"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ViewScript",

  data() {
    return {
      dialog: {
        show: false
      },

      script: {
        descricao: "",
        conteudo: ""
      }
    };
  },

  methods: {
    show(show, scriptObj) {
      this.script = scriptObj;
      this.dialog.show = show;
    }
  }
};
</script>
